import styled from "styled-components";

import { primaryColor } from "../../Subscriptions/variables.styles";

export const JobContainer = styled.div`
  background-color: ${primaryColor};
  padding: 0.5em 0;
  color: white;
  p {
    max-width: 60ch;
  }

  h2 {
    padding-bottom: 1em;
  }

  a {
    display: block;
  }

  .job {
    align-self: center;
  }

  .source {
    margin-top: 1.5em;
    font-size: 1.3rem;

    span {
      display: block;
    }
  }

  @media (min-width: 800px) {
    .col + .col {
      margin-right: 5em;

      padding-bottom: 1em;
    }
    padding: 5em 0;
  }
`;

export const Row = styled.div`
  @media (min-width: 800px) {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
  }
`;

export const Col = styled.div`
  @media (min-width: 800px) {
    width: 100%;
  }
`;

export const TitleSection = styled.div`
  color: white;
  text-align: center;
  margin-bottom: 3em;

  p {
    text-align: center;
    margin: 0 auto;
    max-width: 60ch;
  }
`;

export const Link = styled.a`
  color: white;
  font-weight: 550;
  &:hover {
    text-decoration: none;
  }
`;
